// offlineQueue.js — enfileira POSTs quando não há conexão e reenvia automaticamente
// ao voltar online. Guarda em localStorage para sobreviver a fechar o app.
import { api } from "./api";

const QUEUE_KEY = "dbs_offline_queue";

function readQueue() {
  try { return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]"); } catch { return []; }
}
function writeQueue(q) { localStorage.setItem(QUEUE_KEY, JSON.stringify(q)); }

export function isOffline() {
  return typeof navigator !== "undefined" && !navigator.onLine;
}

export function queuedCount() {
  return readQueue().length;
}

/** Enfileira uma requisição para ser enviada quando voltar online. */
export function enqueue(method, url, data, label = "") {
  const q = readQueue();
  q.push({
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    method, url, data, label,
    created_at: new Date().toISOString(),
  });
  writeQueue(q);
  window.dispatchEvent(new CustomEvent("dbs-queue-changed"));
}

/** Executa o request agora se online; senão enfileira. Retorna {ok, response, queued}. */
export async function apiWithOffline(method, url, data, label = "") {
  if (isOffline()) {
    enqueue(method, url, data, label);
    return { ok: true, queued: true };
  }
  try {
    const res = await api.request({ method, url, data });
    return { ok: true, response: res.data };
  } catch (e) {
    // Se o erro parece de rede (Network Error / offline), enfileira
    const msg = e?.message || "";
    if (msg.toLowerCase().includes("network") || !navigator.onLine) {
      enqueue(method, url, data, label);
      return { ok: true, queued: true };
    }
    throw e;
  }
}

/** Tenta reenviar tudo o que está enfileirado. */
export async function flushQueue() {
  if (isOffline()) return { sent: 0, remaining: queuedCount() };
  const q = readQueue();
  const remaining = [];
  let sent = 0;
  for (const item of q) {
    try {
      await api.request({ method: item.method, url: item.url, data: item.data });
      sent += 1;
    } catch (e) {
      // se erro de servidor (4xx/5xx) descarta o item (não vai passar mesmo);
      // se erro de rede, mantém na fila
      const status = e?.response?.status;
      if (status && status < 500) {
        // client error - descarta pra não travar a fila para sempre
      } else {
        remaining.push(item);
      }
    }
  }
  writeQueue(remaining);
  window.dispatchEvent(new CustomEvent("dbs-queue-changed"));
  return { sent, remaining: remaining.length };
}

// Setup automático: quando voltar online, tenta esvaziar a fila
if (typeof window !== "undefined") {
  window.addEventListener("online", () => { flushQueue().catch(() => {}); });
}
